export const DELIMITER_CHARS = [',', ' ', '\n']
export const DELIMITER_CHARS_REGEXP = new RegExp(DELIMITER_CHARS.join('|'))
export const VALID_EMAIL_REGEXP = /@/
